module.exports = __webpack_public_path__ + "assets/img/mark_red.dcfff213.svg";